module.exports = __webpack_public_path__ + "assets/img/dianjiang11.c72d4bb6.png";